import { Button } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { WarningIcon } from "@phosphor-icons/react";
import { useNavigate } from "@tanstack/react-router";

import { MODAL_HANDLER } from "@/lib/Mantine";

export function EditDriver({ context, id }: ContextModalProps) {
  const navigate = useNavigate();

  const handleDeny = () => {
    context.closeModal(id);
    navigate({ to: "/app/perfil/editar", replace: true });
  };

  const handleCancelQueueModal = () => {
    MODAL_HANDLER.queue.deleteQueue({
      onQueueDeleted() {
        navigate({ to: "/app/perfil/editar", replace: true });
      }
    });
  };

  return (
    <div className="relative flex min-h-80 flex-col justify-between gap-4">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="text-primary bg-primary-100 flex size-16 items-center justify-center rounded-full">
          <WarningIcon weight="bold" size={32} />
        </div>

        <div className="flex flex-col items-center justify-center gap-2 text-center">
          <h1 className="text-2xl font-bold text-gray-700">Atenção!</h1>
          <p className="text-xl text-gray-700">Você está em uma fila no momento. Por isso, só é possível editar os métodos de contatos autorizados do seu perfil.</p>
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <div className="grid grid-cols-1 gap-[inherit] sm:grid-cols-2">
          <Button onClick={handleDeny}>Cancelar</Button>

          <Button onClick={handleDeny} variant="outline">
            Prosseguir
          </Button>
        </div>

        <Button onClick={handleCancelQueueModal} color="red">
          Editar mesmo assim
        </Button>
      </div>
    </div>
  );
}
